import { render, staticRenderFns } from "./DistributionDialog.vue?vue&type=template&id=1db520f7&scoped=true&"
import script from "./DistributionDialog.vue?vue&type=script&lang=ts&"
export * from "./DistributionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DistributionDialog.vue?vue&type=style&index=0&id=1db520f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db520f7",
  null
  
)

export default component.exports